import React, { useCallback, useEffect, useRef, useState } from "react";
import "./Connection.css";
// import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Dropdown, Modal, Row } from "react-bootstrap";
import axios from "../../API/axios";
import {
  getConnectionList,
  getRecommendationList,
  getShortMutualUserInfo,
  invalidateConnectionList,
} from "../../Services/apiService";
import { connection, NewsFeed, post, people } from "../../config/imagesLink";
import Loading from "../Blogs/Loading";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { ShimmerDiv } from "@skeleton";
import RecommendationAction from "./RecommendationAction";
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import MailOutlineSharpIcon from '@mui/icons-material/MailOutlineSharp';
import ReportGmailerrorredSharpIcon from '@mui/icons-material/ReportGmailerrorredSharp';
import { set } from "lodash";
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import LocationOnSharpIcon from '@mui/icons-material/LocationOnSharp';
import CircleIcon from '@mui/icons-material/Circle';
import ConnectionRecommendationAction from "./ConnectionRecommendationAction";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";
import { useTranslation } from "react-i18next";
import GoogleAdUnit from "../../components/GoogleAdUnit";

const { locationIcon } = connection;

const CONNECTION_TAB_MAP = {
  connections: 1,
  sentrequest: 2,
  receivedrequest: 3,
  recommendations: 4,
};

const CONNECTION_TAB_ROUTES = {
  1: "Connections",
  2: "SentRequest",
  3: "ReceivedRequest",
  4: "Recommendations",
};

const getConnectionTabIndex = (routeTab) => {
  const tabKey = (routeTab || "").toLowerCase();
  return CONNECTION_TAB_MAP[tabKey] || 1;
};

const Connection = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [sentPage, setSentPage] = useState(1);
  const [recievePage, setRecievePage] = useState(1);
  const [isError, setIsError] = useState(false);
  const [sentIsError, setSentIsError] = useState(false);
  const [receivedIsError, setReceivedIsError] = useState(false);
  const [recommendedIsError, setRecommendedIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const language = localStorage.getItem("Lang");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const navigate = useNavigate();
  const { tab } = useParams();

  const [showDropdown, setShowDropdown] = useState(false);
  const [activeTab, setActiveTab] = useState(() => getConnectionTabIndex(tab));

  const goToConnectionTab = (tabIndex) => {
    const tabPath = CONNECTION_TAB_ROUTES[tabIndex];
    if (tabPath) {
      window.scrollTo({ top: 0, behavior: "auto" });
      navigate(`/Connections/${tabPath}`, { state: null });
    }
  };

  const [searchUserName, setSearchUserName] = useState("");

  const options = [
    { value: "Mumbai", label: "Mumbai" },
    { value: "Thane", label: "Thane" },
    { value: "Pune", label: "Pune" },
  ];

  const sessionId = localStorage.getItem("sessionId");
  //************************ Connection  List   ************************//
  const [ConnectionList, setConnectionList] = useState([]);
  const [searchConnectList, setSearchConnectList] = useState([]);
  const [nextAllConBatchLoading, setNextAllConBatchLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState(searchUserName);

  // const ConnectionListAll = useCallback(async () => {
  //   const data = {
  //     deviceType: "Web",
  //     sessionId,
  //     pageNumber: page,
  //     pageSize: 5,
  //     type: "ConnectionList",
  //     search: debouncedSearch,
  //     langKey: language === "en" ? "" : language,
  //   };

  //   if (page === 1) setIsLoading(true);
  //   setNextAllConBatchLoading(true);

  //   try {
  //     const resData = await axios.post("Connection/GetConnectionList", data);
  //     console.log("API Response:", resData);

  //     const viewList = resData?.data?.responseData?.viewList || [];
  //     const total = resData?.data?.responseData?.paging?.totalPages || 1;

  //     // ✅ Search Mode
  //     if (debouncedSearch !== "") {
  //       // setConnectionList([]);
  //       setSearchConnectList(viewList);
  //     }

  //     else {
  //       setSearchConnectList([]);
  //       if (page === 1) {
  //         setConnectionList(viewList);
  //       } else {
  //         setConnectionList((prev) => {
  //           const newItems = viewList.filter(
  //             (item) => !prev.some((p) => p.cnctnId === item.cnctnId)
  //           );
  //           return [...prev, ...newItems];
  //         });
  //       }
  //     }

  //     // ✅ Error / empty handling
  //     if (viewList.length === 0 && page === 1) {
  //       setIsError(true);
  //     } else {
  //       setIsError(false);
  //     }

  //     setTotalPages(total);
  //     setHasMoreData(page < total);
  //   } catch (error) {
  //     console.error("API Error:", error);
  //     if (error.response?.status === 404) {
  //       setIsError(true);
  //     }
  //   } finally {
  //     setIsLoading(false);
  //     setNextAllConBatchLoading(false);
  //   }
  // }, [page, debouncedSearch, sessionId]);

  // 🔹 On tab change or search change -> reset and fetch

  const ConnectionListAll = useCallback(async () => {
    const data = {
      deviceType: "Web",
      sessionId,
      pageNumber: page,
      pageSize: 10,
      type: "ConnectionList",
      search: debouncedSearch,
      langKey: language === "en" ? "" : language,
    };

    if (page === 1) setIsLoading(true);
    setNextAllConBatchLoading(true);

    try {
      const resData = await getConnectionList(data);

      const viewList = resData?.data?.responseData?.viewList || [];
      const total = resData?.data?.responseData?.paging?.totalPages || 1;

      console.log("Page:", page);
      console.log("New Data:", viewList);

      // 🔎 SEARCH MODE
      if (debouncedSearch !== "") {
        setSearchConnectList(viewList);
      }
      else {
        setSearchConnectList([]);

        if (page === 1) {
          setConnectionList(viewList);
        }
        else {
          // ✅ FIXED DUPLICATE FILTER USING userUid
          setConnectionList((prev) => {
            const existingIds = new Set(prev.map((p) => p.userUid));

            const filteredData = viewList.filter(
              (item) => !existingIds.has(item.userUid)
            );

            return [...prev, ...filteredData];
          });
        }
      }

      // Empty handling
      setIsError(viewList.length === 0 && page === 1);

      setTotalPages(total);
      setHasMoreData(page < total);

    } catch (error) {
      console.error("API Error:", error);
      setIsError(true);
    } finally {
      setIsLoading(false);
      setNextAllConBatchLoading(false);
    }
  }, [page, debouncedSearch, sessionId, language]);

  useEffect(() => {
    if (activeTab === 1) {
      setPage(1);
      setConnectionList([]);
    }
  }, [activeTab, debouncedSearch]);

  useEffect(() => {
    if (activeTab === 1) {
      ConnectionListAll();
    }
  }, [page, activeTab, debouncedSearch]);

  // 🔹 Infinite scroll -> load next page
  // useEffect(() => { 
  //   if (activeTab !== 1) {
  //     return; // Exit early if not on tab 1
  //   }
  //   if (page === 1 || (debouncedSearch === "" && page > 1)) {
  //     ConnectionListAll();
  //   }
  // }, [page, activeTab, debouncedSearch, ConnectionListAll]);

  // 🔹 Scroll event listener
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop + 50 >=
        document.documentElement.offsetHeight &&
        !nextAllConBatchLoading &&
        hasMoreData &&
        activeTab === 1 &&
        debouncedSearch === ""
      ) {
        setPage((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [nextAllConBatchLoading, hasMoreData, activeTab, debouncedSearch]);


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchUserName);
    }, 1000); // 🔹 500ms debounce delay

    return () => {
      clearTimeout(handler);
    };
  }, [searchUserName]);


  //************************Connection List ************************//

  const [recommendationList, setRecommendationList] = useState([]);
  const [RecommendedPage, setRecommendedPage] = useState(1);
  //************************ Get Recommendations List  ************************//
  const [nextRecomBatchLoading, setNextRecomBatchLoading] = useState(false);
  const [totalPagesRecom, setTotalPagesRecom] = useState(1);
  const [hasMoreDataRecom, setHasMoreDataRecom] = useState(true);

  const GetRecommendation = async (page = 1) => {
    // Stop if no more data
    if (!hasMoreDataRecom && page > 1) return;

    // Show correct loader
    if (page === 1) setIsLoading(true);
    else setNextRecomBatchLoading(true);

    setRecommendedIsError(false);

    try {
      const result = await getRecommendationList({
        pageNumber: page,
        pageSize: 10,
      });

      const Response = result?.data?.responseData?.viewList || [];
      const totalPages = result?.data?.responseData?.paging?.totalPages || 1;

      if (Response.length === 0 || Response.status === 204) {
        if (page === 1)
          setRecommendedIsError(true);
        setHasMoreDataRecom(false);
        return;
      }


      setRecommendationList((prev) => {
        const existingIds = new Set(prev.map((item) => item.userUid));
        const uniqueNew = Response.filter((x) => !existingIds.has(x.userUid));
        return [...prev, ...uniqueNew];
      });

      setTotalPagesRecom(totalPages);
      if (page >= totalPages) setHasMoreDataRecom(false);
    } catch (error) {
      console.error("Error fetching recommendations:", error);
      if (page === 1)
        setRecommendedIsError(true);
    } finally {
      setIsLoading(false);
      setNextRecomBatchLoading(false);
    }
  };
  useEffect(() => {
    // if (activeTab=== 4 && RecommendedPage <= totalPagesRecom) {
    if (activeTab === 4) {
      setRecommendationList([]);
      setRecommendedPage(1);
      setHasMoreDataRecom(true);
      GetRecommendation(1);
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 4 && RecommendedPage > 1 && hasMoreDataRecom) {
      GetRecommendation(RecommendedPage);
    }
  }, [RecommendedPage]);


  const handleInfiniteScroll = () => {
    if (activeTab !== 4 || isLoading || nextRecomBatchLoading || !hasMoreDataRecom) return;

    if (
      window.innerHeight + document.documentElement.scrollTop + 1 >=
      document.documentElement.scrollHeight
    ) {
      setRecommendedPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleInfiniteScroll);
    return () => window.removeEventListener("scroll", handleInfiniteScroll);
  }, [activeTab, isLoading, nextRecomBatchLoading, hasMoreDataRecom]);

  //************************  Get Recommendations List End  ************************//

  //************************Sent Connect Request List   ************************//
  const [sentRequest, setsentRequest] = useState([]);
  const [nextReqConBatchLoading, setNextReqConBatchLoading] = useState(false);
  const [totalPagesReq, setTotalPagesReq] = useState(1);
  const [hasMoreDataReq, setHasMoreDataReq] = useState(true);

  const sentRequestList = async (page = sentPage) => {
    if (!hasMoreDataReq && page > 1) {
      return;
    }

    if (page === 1) {
      setIsLoading(true);   // shimmer ke liye
    } else {
      setNextReqConBatchLoading(true); // bottom loader ke liye
    }

    setSentIsError(false);
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: page,
      pageSize: 10,
      type: "SentRequestList",
      langKey: language === "en" ? "" : language,
    };
    try {
      const resData = await getConnectionList(data);

      const newItems = resData.data?.responseData?.viewList || [];
      const totalPages = resData?.data?.responseData?.paging?.totalPages || 1;

      if (newItems.length === 0) {
        if (page === 1) setSentIsError(true);
        setHasMoreDataReq(false);
        return;
      }

      setsentRequest((prev) => {
        const existingIds = new Set(prev.map(item => item.userUid));
        const filteredNewItems = newItems.filter(item => !existingIds.has(item.userUid));
        return [...prev, ...filteredNewItems];
      });

      // const totalPages = resData.data.responseData.paging.totalPages;
      setTotalPagesReq(totalPages);

      if (page >= totalPages || newItems.length < 10) {
        setHasMoreDataReq(false);
      }
    } catch (error) {
      console.error(error);
      if (page === 1) setSentIsError(true);
      setHasMoreDataReq(false);
    } finally {
      setIsLoading(false);
      setNextReqConBatchLoading(false);
    }
  };


  useEffect(() => {
    // if ((sentPage <= totalPagesReq || totalPagesReq === 0) && activeTab===2) {
    if (activeTab === 2) {
      console.log('sentpage is hitting');
      setsentRequest([]);
      setSentPage(1);
      setHasMoreDataReq(true);
      sentRequestList(1);
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 2 && sentPage > 1 && hasMoreDataReq) {
      sentRequestList(sentPage);
    }
  }, [sentPage]);

  const handleSentReqInfiniteScroll = () => {
    if (activeTab !== 2 || isLoading || nextReqConBatchLoading || !hasMoreDataReq) return;

    if (
      window.innerHeight + document.documentElement.scrollTop + 1 >=
      document.documentElement.scrollHeight
    ) {
      setSentPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleSentReqInfiniteScroll);
    return () => window.removeEventListener("scroll", handleSentReqInfiniteScroll);
  }, [activeTab, isLoading, nextReqConBatchLoading, hasMoreDataReq]);
  //************************Sent Connect Request List ************************//

  //************************Received Connect Request List   ************************//
  const [RecievedRequest, setRecievedRequest] = useState([]);
  const [nextReceivedConBatchLoading, setNextReceivedConBatchLoading] = useState(false);
  const [totalPagesReceived, setTotalPagesReceived] = useState(1);
  const [hasMoreDataReceived, setHasMoreDataReceived] = useState(true);

  const ReceivedRequestList = async (page = recievePage) => {
    if (!hasMoreDataReceived && recievePage > 1) {
      // setNextReceivedConBatchLoading(false);
      return;
    }

    if (page === 1) {
      setIsLoading(true);   // shimmer ke liye
    } else {
      setNextReceivedConBatchLoading(true); // bottom loader ke liye
    }

    setReceivedIsError(false);
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: page,
      pageSize: 10,
      type: "ReceivedRequestList",
      langKey: language === "en" ? "" : language,
    };

    try {
      const resData = await getConnectionList(data);

      const newItems = resData.data?.responseData?.viewList || [];
      const totalPages = resData?.data?.responseData?.paging?.totalPages || 1;

      if (newItems.length === 0) {
        if (page === 1) setReceivedIsError(true);
        setHasMoreDataReceived(false);
        return;
      }

      setRecievedRequest((prev) => {
        const existingIds = new Set(prev.map(item => item.cnctnId));
        const filteredNewItems = newItems.filter(item => !existingIds.has(item.cnctnId));
        return [...prev, ...filteredNewItems];
      });

      // const totalPages = resData.data.responseData.paging.totalPages;
      setTotalPagesReceived(totalPages);

      if (page >= totalPages || newItems.length < 10) {
        setHasMoreDataReceived(false);
      }

    } catch (error) {
      // if (error.response && error.response.status === 404) {
      //   setReceivedIsError(true);
      // } else {
      //   console.log(error);
      // }
      // setIsLoading(false);
      // setNextReceivedConBatchLoading(false);
      // if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
      //   setUnauthorisedModal(true)
      // }
      console.error(error);
      if (page === 1) setReceivedIsError(true);
      setHasMoreDataReceived(false);
      if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
        setUnauthorisedModal(true)
      }
    } finally {
      setIsLoading(false);
      setNextReceivedConBatchLoading(false);
    }
  };

  useEffect(() => {
    // if (activeTab === 3 && recievePage <= totalPagesReceived) {
    if (activeTab === 3) {
      ReceivedRequestList(1);
      setRecievedRequest([]);
      setRecievePage(1);
      setHasMoreDataReceived(true);
    }
  }, [activeTab]);
  useEffect(() => {
    if (activeTab === 3 && recievePage > 1 && hasMoreDataReceived) {
      ReceivedRequestList(recievePage);
    }
  }, [activeTab, recievePage, hasMoreDataReceived]);

  const handleRecieveReqInfiniteScroll = () => {
    if (
      activeTab !== 3 ||
      isLoading ||
      nextReceivedConBatchLoading ||
      !hasMoreDataReceived
    ) {
      return;
    }

    if (
      window.innerHeight + document.documentElement.scrollTop + 1 >=
      document.documentElement.scrollHeight
    ) {
      setRecievePage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleRecieveReqInfiniteScroll);
    return () => window.removeEventListener("scroll", handleRecieveReqInfiniteScroll);
  }, [activeTab, isLoading, nextReceivedConBatchLoading, hasMoreDataReceived]);

  //************************Received Connect Request List ************************//

  //************************Cancel Request   ************************//
  const [show, setShow] = useState(false);
  const cancelRequestClose = () => {
    setShow(false);
  };
  const [userUID, setuserUID] = useState("");

  const CancelRequest = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: userUID,
      langKey: language === "en" ? "" : language,
    };

    try {
      await axios
        .post("Connection/CancelConnectionRequest", data)
        .then((resData) => {
          setShow(false);
          setToastMessage(resData.data.message);
          setShowToast(true);

          // setsentRequest((prev) => prev.filter((item) => item.userUid !== id));
          setsentRequest((prev) => prev.filter((item) => item.userUid !== id));
          // sentRequestList();
          // sentRequestList()
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Remove Connection Request   ************************//

  const RemoveRequest = async (id) => {
    const Removedata = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: selectedUserId,
      langKey: language === "en" ? "" : language,
    };
    console.log("remove id", Removedata);
    try {
      await axios
        .post("Connection/DisconnectUser ", Removedata)
        .then((resData) => {
          console.log("remove res", resData);
          //   setShowRemove(!showRemove);
          //   toast.success(resData.data.message);
          setToastMessage(resData.data.message);
          setShowToast(true);
          invalidateConnectionList();
          ConnectionListAll();
          setConnectionList((prev) =>
            prev.filter((item) => item.userUid !== selectedUserId)
          );

          // Agar search list me bhi dikh raha ho to wahan se bhi hatao
          setSearchConnectList((prev) =>
            prev.filter((item) => item.userUid !== selectedUserId)
          );
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Remove Connection Request  ************************//

  //************************Accept Request   ************************//
  const AcceptRequest = async (userId, cnctnId) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: userId,
      // connectID: cnctnId,
      actionType: "Accept",
      langKey: language === "en" ? "" : language,
    };
    console.log('cnctnId', data);

    try {
      await axios
        .post("Connection/ConnectionRequestAction ", data)
        .then((resData) => {
          setToastMessage(resData.data.message);
          setShowToast(true);
          setRecievedRequest((prev) => prev.filter((item) => item.userUid !== userId));
          invalidateConnectionList();
          ReceivedRequestList();
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Accept Request ************************//

  //************************Reject Request   ************************//
  const RejectRequest = async (userId, cnctnId) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: userId,
      // connectID: cnctnId,
      actionType: "Reject",
      langKey: language === "en" ? "" : language,
    };
    // console.log(data);
    try {
      await axios
        .post("Connection/ConnectionRequestAction ", data)
        .then((resData) => {
          setToastMessage(resData.data.message);
          setShowToast(true);
          setRecievedRequest((prev) => prev.filter((item) => item.userUid !== userId));
          invalidateConnectionList();
          ReceivedRequestList();
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Reject Request ************************//


  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(null);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggleDropdown = (index) => {
    setShowDropdown((prev) => (prev === index ? null : index));
  };
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const handleShowModal = (item) => {
    setSelectedItem(item);
    setSelectedUserId(item.userUid);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

  const handleConfirmAction = () => {
    RemoveRequest();
    handleCloseModal();
  };

  //************************ short mutual list ************************//
  const [shortMutualList, setShortMutualList] = useState({});
  console.log('shortMutualList', shortMutualList);

  useEffect(() => {
    if (recommendationList && recommendationList.length > 0) {
      recommendationList.forEach((item) => {
        fetchShortMutualList(item.userUid);
      });
    }
  }, [recommendationList]);
  useEffect(() => {
    if (sentRequest && sentRequest.length > 0) {
      sentRequest.forEach((item) => {
        fetchShortMutualList(item.userUid);
      });
    }
  }, [sentRequest]);
  useEffect(() => {
    if (RecievedRequest && RecievedRequest.length > 0) {
      RecievedRequest.forEach((item) => {
        fetchShortMutualList(item.userUid);
      });
    }
  }, [RecievedRequest]);
  useEffect(() => {
    if (ConnectionList && ConnectionList.length > 0) {
      ConnectionList.forEach((item) => {
        fetchShortMutualList(item.userUid);
      });
    }
  }, [ConnectionList]);

  const fetchShortMutualList = async (id) => {
    try {
      const responseData = await getShortMutualUserInfo(id);
      setShortMutualList((prevState) => ({
        ...prevState,
        [id]: responseData,
      }));
      setIsLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // setIsError(true);
      } else {
        console.log(error);
      }
      setIsLoading(false);
    }
  };
  //************************ short mutual list ************************//


  const renderTabContent = () => {
    switch (activeTab) {
      case 1:
        return (
          <>
            <div className="mb-2">
              <Row>
                <input
                  type="email"
                  className="form-control p-2 connection-input HuzChnagesConnection"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder={t("People.Search user")}
                  onChange={(e) => {
                    setSearchUserName(e.target.value);
                  }}
                  value={searchUserName}
                />
              </Row>
            </div>
            {isLoading ? (
              <div className="mt-3">
                <ShimmerDiv
                  height={100}
                  width={"100%"}
                  className="mb-2"
                />
                <ShimmerDiv
                  height={100}
                  width={"100%"}
                  className="mb-2"
                />
                <ShimmerDiv
                  height={100}
                  width={"100%"}
                  className="mb-2"
                />
              </div>
            ) : isError ? (
              <div className="error-connection">
                <img src={post.errorSmall} alt="404 Not Found" />
              </div>
            ) : debouncedSearch !== "" ? (
              // searchconnectList &&
              searchConnectList?.map((item, index) => {
                console.log("mainconnectionssssssssss", item);
                return (
                  <div key={index}>
                    <Row>
                      <div className="resume-cont New-resume-cont d-block d-md-flex">
                        <Col md={2} className="m-auto">
                          <Link to={`/User/${item.userUid}`}>
                            <div className="image-cont">
                              <img
                                src={item?.profilPic}
                                alt=""
                                width={70}
                                height={70}
                                style={{ borderRadius: "50px" }}
                                onError={handleProfileImageError}
                              />
                            </div>
                          </Link>
                        </Col>
                        <Col md={7}>
                          <div className="userName">
                            <Link to={`/User/${item.userUid}`}>
                              <h1>
                                {item?.fullName}{" "}
                                <span className="f-12 fw-100">
                                  {item?.userName}
                                </span>{" "}
                              </h1>
                            </Link>
                          </div>
                          <div className="designation">
                            <h1>{item?.title}</h1>
                          </div>
                          <div className="designation">
                            <h1>{item?.headLine}</h1>
                          </div>
                          <div className="location">
                            {item?.location && (
                              <>
                                {/* <img src={locationIcon} alt="" /> */}
                                <LocationOnSharpIcon className="ConnectionIcons" />
                                <span className="locationText">
                                  {item?.location}
                                </span>
                              </>
                            )}
                          </div>
                          <div className="vectorUserImage">
                            {/* <img src={userAvatar} alt="" /> */}
                            <AccountCircleSharpIcon className="ConnectionIcons" />
                            <span className="followerText ms-2">
                              {item?.followersCount}  {t("Connections.Followers")}
                            </span>
                          </div>
                          <div className="d-flex mt-1 align-items-center">
                            <div className="circle-container">
                              {shortMutualList[item.userUid]?.pics?.map(
                                (pic, picIndex) => (
                                  <img
                                    src={pic}
                                    alt={`Circle ${picIndex + 1}`}
                                    className="circle-img"
                                    key={picIndex}
                                    onError={handleProfileImageError}
                                  />
                                )
                              )}
                            </div>
                            <div className={`f-12 text ${shortMutualList?.[item.userUid]?.count === 1 ? 'ms-1' : 'ms-2'}`} >
                              {shortMutualList[item.userUid]?.text}
                            </div>
                          </div>
                        </Col>
                        <Col
                          md={3}
                          className="resume-action-button"
                        >
                          <Link
                            to={`/Message/${item?.userUid}`}
                            className="me-2"
                          >
                            <MailOutlineSharpIcon className="material-symbols-sharp" />
                          </Link>
                          <div
                            className="postMenu pointer"
                            onClick={() => handleToggleDropdown(index)}
                          >
                            <MoreHorizSharpIcon className="material-symbols-sharp" />

                            {showDropdown === index && (
                              <Dropdown.Menu
                                show={showDropdown === index}
                                ref={dropdownRef}
                                className="InteractionModal"
                              >
                                <Dropdown.Item
                                  as="button"
                                  className="dropdownList p-0"
                                >
                                  <Link onClick={() => handleShowModal(item)}>
                                    <div className="d-flex align-items-center">
                                      <ReportGmailerrorredSharpIcon
                                        className="material-symbols-sharp me-2" />
                                      <span className="dropdownTxt f-14">
                                        {/* Disconnect */}
                                        {t("Connections.Disconnect")}
                                      </span>
                                    </div>
                                    <p className="f-12 dropdownPara">
                                      {/* Disconnect User */}
                                      {t("Connections.Disconnect User")}
                                    </p>
                                  </Link>
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            )}
                          </div>
                        </Col>

                      </div>
                    </Row>
                  </div>
                );
              })
            ) : (
              // ConnectionList &&
              ConnectionList?.map((item, index) => {
                console.log("mainconnection", item);
                return (
                  <div key={index}>
                    <Row>
                      <div className="resume-cont New-resume-cont">
                        <Col lg={1} md={2} className="resume-card-upper connection-imageProf IpadWidth">
                          <Link to={`/User/${item.userUid}`}>
                            <div className="image-cont">
                              <img
                                src={item?.profilPic}
                                alt=""
                                width={70}
                                height={70}
                                style={{ borderRadius: "50px" }}
                                onError={handleProfileImageError}
                              />
                            </div>
                          </Link>
                          {item.isOnline === false ? '' : (
                            <>
                              {/* rgb(0 39 96) */}
                              <div className="activeCircle">
                                <CircleIcon style={{
                                  color: ' #29cd29',
                                  fontSize: 'large',
                                  background: 'rgb(41, 205, 41)',
                                  borderRadius: ' 50%',
                                  width: '13px',
                                  height: '13px',
                                  border: '1px solid white',
                                  boxShadow: '1px 1px 6px 1px white',
                                }} />
                              </div>
                            </>
                          )}
                        </Col>

                        <div className="resume-card-inner resume-card-inner-New">
                          <Col md={7}>
                            <div className="userName">
                              <Link to={`/User/${item.userUid}`}>
                                <h1>
                                  {item?.fullName}{" "}
                                  <span className="f-12 fw-100" style={{ color: '#3a74f6' }}>
                                    {item?.userName}
                                  </span>{" "}
                                </h1>
                              </Link>
                            </div>
                            <div className="designation">
                              <h1>{item?.title}</h1>
                            </div>
                            <div className="designation">
                              <h1>{item?.headLine}</h1>
                            </div>
                            <div className="location">
                              {item?.location && (
                                <>
                                  {/* <img src={locationIcon} alt="" /> */}
                                  <LocationOnSharpIcon className="ConnectionIcons" />
                                  <span className="locationText">
                                    {item?.location}
                                  </span>
                                </>
                              )}
                            </div>
                            <div className="vectorUserImage">
                              {/* <img src={userAvatar} alt="" /> */}
                              <AccountCircleSharpIcon className="ConnectionIcons" />
                              <span className="followerText ms-2">
                                {item?.followersCount} {t("Connections.Followers")}
                              </span>
                            </div>
                            <div className="d-flex mt-1 align-items-center">
                              <div className="circle-container">
                                {shortMutualList[item.userUid]?.pics?.map(
                                  (pic, picIndex) => (
                                    <img
                                      src={pic}
                                      alt={`Circle ${picIndex + 1}`}
                                      className="circle-img"
                                      key={picIndex}
                                      onError={handleProfileImageError}
                                    />
                                  )
                                )}
                              </div>
                              <div className={`f-12 text ${shortMutualList?.[item.userUid]?.count === 1 ? 'ms-1' : 'ms-2'}`} >
                                {shortMutualList[item.userUid]?.text}
                              </div>
                            </div>
                          </Col>
                          <Col
                            md={3}
                            className="d-flex align-items-center justify-content-end"
                          >
                            <Link
                              to={`/Message/${item?.userUid}`}
                              className="me-2"
                            >
                              <MailOutlineSharpIcon className="material-symbols-sharp" />
                            </Link>
                            <div
                              className="postMenu pointer"
                              onClick={() => handleToggleDropdown(index)}
                            >
                              <MoreHorizSharpIcon className="material-symbols-sharp" />

                              {showDropdown === index && (
                                <Dropdown.Menu
                                  show={showDropdown === index}
                                  ref={dropdownRef}
                                  className="InteractionModal"
                                >
                                  <Dropdown.Item
                                    as="button"
                                    className="dropdownList p-0"
                                  >
                                    <Link onClick={() => handleShowModal(item)}>
                                      <div className="d-flex align-items-center">
                                        <ReportGmailerrorredSharpIcon
                                          className="material-symbols-sharp me-2" />
                                        <span className="dropdownTxt f-14">
                                          {/* Disconnect */}
                                          {t("Connections.Disconnect")}
                                        </span>
                                      </div>
                                      <p className="f-12 dropdownPara">
                                        {t("Connections.Disconnect User")}
                                        {/* Disconnect User */}
                                      </p>
                                    </Link>
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              )}
                            </div>
                          </Col>
                        </div>
                      </div>
                    </Row>
                  </div>
                );

              })
            )}
            {!hasMoreData && ConnectionList.length > 10 && (
              <p className="text-center">{t("Newsfeed.No more data available")}</p>
            )}
            {nextAllConBatchLoading && (
              <div className="text-center">
                <img src={post?.loader} width={50} />
              </div>
            )}
          </>
        );
      case 2:
        return (
          <>
            {isLoading && sentRequest.length === 0 ? (
              <div className="mt-3">
                <ShimmerDiv
                  height={100}
                  width={"100%"}
                  className="mb-2"
                />
                <ShimmerDiv
                  height={100}
                  width={"100%"}
                  className="mb-2"
                />
                <ShimmerDiv
                  height={100}
                  width={"100%"}
                  className="mb-2"
                />
              </div>
            ) : sentIsError ? (
              <div className=" error-connection">
                <img src={post.errorSmall} alt="404 Not Found" />
              </div>
            ) :
              (
                sentRequest &&
                sentRequest.map((item, index) => {
                  return (
                    <Row key={index}>
                      <div className="resume-cont New-resume-cont">
                        <Col lg={1} md={2} className="resume-card-upper IpadWidth">
                          <Link to={`/User/${item.userUid}`} key={index}>
                            <div className="image-cont">
                              <img
                                src={item?.profilPic}
                                alt=""
                                width={70}
                                height={70}
                                style={{ borderRadius: "50px" }}
                                onError={handleProfileImageError}
                              />
                            </div>
                          </Link>
                        </Col>

                        <div className="resume-card-inner resume-card-inner-New">
                          <Col md={7}>
                            <div className="userName">
                              <Link to={`/User/${item.userUid}`}>
                                <h1>
                                  {item?.fullName}{" "}
                                  <span className="f-12 fw-100" style={{ color: '#3a74f6' }}>
                                    {item?.userName}
                                  </span>{" "}
                                </h1>
                              </Link>
                            </div>
                            <div className="designation">
                              <h1>{item?.title}</h1>
                            </div>
                            <div className="designation">
                              <h1>{item?.headLine}</h1>
                            </div>
                            <div className="location">
                              <div>
                                {item?.location && (
                                  <>
                                    {/* <img src={locationIcon} alt="" /> */}
                                    <LocationOnSharpIcon className="ConnectionIcons" />
                                    <span className="locationText">
                                      {item?.location}
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                            <div className="vectorUserImage">
                              {/* <img src={userAvatar} alt="" /> */}
                              <AccountCircleSharpIcon className="ConnectionIcons" />
                              <span className="followerText ms-2">
                                {item?.followersCount} {t("Connections.Followers")}
                              </span>
                            </div>
                            <div className="d-flex mt-1 align-items-center">
                              <div className="circle-container">
                                {shortMutualList[item.userUid]?.pics?.map(
                                  (pic, picIndex) => (
                                    <img
                                      src={pic}
                                      alt={`Circle ${picIndex + 1}`}
                                      className="circle-img"
                                      key={picIndex}
                                      onError={handleProfileImageError}
                                    />
                                  )
                                )}
                              </div>
                              <div className={`f-12 text ${shortMutualList?.[item.userUid]?.count === 1 ? 'ms-1' : 'ms-2'}`} >
                                {shortMutualList[item.userUid]?.text}
                              </div>
                            </div>
                          </Col>
                          <Col
                            md={3}
                            className="resume-action-button"
                          >
                            <button
                              type="submit"
                              className="wljSecondaryBtn send-request-cancel"
                              onClick={() => {
                                setShow(!show);
                                setuserUID(item.userUid);
                              }}
                            >
                              {t("Connections.Cancel")}
                            </button>
                          </Col>
                        </div>
                      </div>
                    </Row>
                  );
                })

              )}
            {/* {
              !hasMoreDataReq ? (''
              ) : (
                <p className="text-center">No more data available</p>
              )
            } */}
            {!hasMoreData && sentRequest.length > 10 && (
              <p className="text-center">{t("Newsfeed.No more data available")}</p>
            )}

            {nextReqConBatchLoading && sentRequest.length && (
              <div className="text-center">
                <img src={post?.loader} width={50} />
              </div>
            )}
          </>
        );
      case 3:
        return (
          <>
            {isLoading && RecievedRequest === 0 ? (
              <div className="mt-3">
                <ShimmerDiv
                  height={100}
                  width={"100%"}
                  className="mb-2"
                />
                <ShimmerDiv
                  height={100}
                  width={"100%"}
                  className="mb-2"
                />
                <ShimmerDiv
                  height={100}
                  width={"100%"}
                  className="mb-2"
                />
              </div>
            ) : receivedIsError ? (
              <div className=" error-connection">
                <img src={post.errorSmall} alt="404 Not Found" />
              </div>
            ) : (
              // RecievedRequest &&
              RecievedRequest?.map((item, index) => {
                return (
                  <>
                    <Row key={index}>
                      <div className="resume-cont New-resume-cont">
                        <Col lg={1} md={2} className="resume-card-upper IpadWidth">
                          <Link to={`/User/${item.userUid}`} key={index}>
                            <div className="image-cont">
                              <img
                                src={item?.profilPic}
                                alt=""
                                width={70}
                                height={70}
                                style={{ borderRadius: "50px" }}
                                onError={handleProfileImageError}
                              />
                            </div>
                          </Link>
                        </Col>

                        <div className="resume-card-inner resume-card-inner-New">
                          <Col md={6}>
                            <div className="userName">
                              <Link to={`/User/${item.userUid}`}>
                                <h1>
                                  {item?.fullName}{" "}
                                  <span className="f-12 fw-100" style={{ color: '#3a74f6' }}>
                                    {item?.userName}
                                  </span>{" "}
                                </h1>
                              </Link>
                            </div>
                            <div className="designation">
                              <h1>{item?.title}</h1>
                            </div>
                            <div className="designation">
                              <h1>{item?.headLine}</h1>
                            </div>
                            <div className="location">
                              <div>
                                {item?.location && (
                                  <>
                                    {/* <img src={locationIcon} alt="" /> */}
                                    <LocationOnSharpIcon className="ConnectionIcons" />
                                    <span className="locationText">
                                      {item?.location}
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                            <div className="vectorUserImage">
                              {/* <img src={userAvatar} alt="" /> */}
                              <AccountCircleSharpIcon className="ConnectionIcons" />
                              <span className="followerText ms-2">
                                {item?.followersCount}  {t("Connections.Followers")}
                              </span>
                            </div>
                            <div className="d-flex mt-1 align-items-center">
                              <div className="circle-container">
                                {shortMutualList[item.userUid]?.pics?.map(
                                  (pic, picIndex) => (
                                    <img
                                      src={pic}
                                      alt={`Circle ${picIndex + 1}`}
                                      className="circle-img"
                                      key={picIndex}
                                      onError={handleProfileImageError}
                                    />
                                  )
                                )}
                              </div>
                              <div className={`f-12 text ${shortMutualList?.[item.userUid]?.count === 1 ? 'ms-1' : 'ms-2'}`} >
                                {shortMutualList[item.userUid]?.text}
                              </div>
                            </div>
                          </Col>
                          <Col
                            md={4}
                            className="resume-action-button"
                          >
                            <button
                              type="submit"
                              className="wljPrimaryBtn"
                              style={{ width: "100px" }}
                              onClick={() => {
                                AcceptRequest(item.userUid, item.cnctnId);
                              }}
                            >
                              {t("Connections.Accept")}
                            </button>
                            <button
                              type="submit"
                              className="wljSecondaryBtn"
                              style={{ width: "100px" }}
                              onClick={() => {
                                RejectRequest(item.userUid, item.cnctnId);
                              }}
                            >
                              {t("Connections.Reject")}
                            </button>
                          </Col>
                        </div>
                      </div>
                    </Row>
                  </>
                );
              })
            )}
            {/* {
              hasMoreDataReceived ? (''
              ) : (
                <p className="text-center">No more data available</p>
              )
            } */}
            {
              !hasMoreDataReceived && RecievedRequest.length > 10 && (

                <p className="text-center">{t("Newsfeed.No more data available")}</p>
              )
            }
            {nextReceivedConBatchLoading && RecievedRequest.length > 0 && (
              <div className="text-center">
                <img src={post?.loader} width={50} />
              </div>
            )}
          </>
        );
      case 4:
        return (
          <>
            {isLoading && recommendationList.length === 0 ? (
              <div className="mt-3">
                <ShimmerDiv
                  height={100}
                  width={"100%"}
                  className="mb-2"
                />
                <ShimmerDiv
                  height={100}
                  width={"100%"}
                  className="mb-2"
                />
                <ShimmerDiv
                  height={100}
                  width={"100%"}
                  className="mb-2"
                />
              </div>
            ) : recommendedIsError ? (
              <div className=" error-connection">
                <img src={post.errorSmall} alt="404 Not Found" />
              </div>
            ) : (
              // recommendationList &&
              recommendationList?.map((item, index) => {
                console.log("recommendationListcon", item);
                return (
                  <>
                    <Row key={index}>
                      <div className="resume-cont New-resume-cont">
                        <Col lg={1} md={2} className="resume-card-upper IpadWidth">
                          <Link to={`/User/${item.userUid}`} key={index}>
                            <div className="image-cont">
                              <img
                                src={item?.profilPic}
                                alt=""
                                width={70}
                                height={70}
                                style={{ borderRadius: "50px" }}
                                onError={handleProfileImageError}
                              />
                            </div>
                          </Link>
                        </Col>

                        <div className="resume-card-inner resume-card-inner-New">
                          <Col md={5}>
                            <div className="userName">
                              <Link to={`/User/${item.userUid}`}>
                                <h1>
                                  {item?.fullName}{" "}
                                  <span className="f-12 fw-100" style={{ color: '#3a74f6' }}>
                                    {item?.nameTag}
                                  </span>
                                </h1>
                              </Link>
                            </div>
                            <div className="designation">
                              <h1>{item?.title}</h1>
                            </div>
                            <div className="designation">
                              <h1>{item?.headLine}</h1>
                            </div>
                            <div className="location">
                              <div>
                                {item?.location && (
                                  <>
                                    {/* <img src={locationIcon} alt="" /> */}
                                    <LocationOnSharpIcon className="ConnectionIcons" />
                                    <span className="locationText">
                                      {item?.location}
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                            <div className="vectorUserImage">
                              {/* <img src={userAvatar} alt="" /> */}
                              <AccountCircleSharpIcon className="ConnectionIcons" />
                              <span className="followerText ms-2">
                                {item?.followersCount}  {t("Connections.Followers")}
                              </span>
                            </div>
                            <div className="d-flex mt-1 align-items-center">
                              <div className="circle-container">
                                {shortMutualList[item.userUid]?.pics?.map(
                                  (pic, picIndex) => (
                                    <img
                                      src={pic}
                                      alt={`Circle ${picIndex + 1}`}
                                      className="circle-img"
                                      key={picIndex}
                                      onError={handleProfileImageError}
                                    />
                                  )
                                )}
                              </div>
                              {/* <div className={`f-12 text ${shortMutualList?.[item.userUid]?.count === 1 ? 'ms-1' : 'ms-2'}`} >
                                {shortMutualList[item.userUid]?.text}
                              </div> */}
                              {(() => {
                                const fullText = shortMutualList[item.userUid]?.text || "";
                                const truncatedText =
                                  fullText.length > 30 ? fullText.substring(0, 30) + "..." : fullText;

                                return (
                                  <div
                                    className={`f-12 text ${shortMutualList?.[item.userUid]?.count === 1 ? "ms-1" : "ms-2"
                                      }`}
                                    title={fullText} // Tooltip on hover
                                  >
                                    {truncatedText}
                                  </div>
                                );
                              })()}
                            </div>
                          </Col>
                          <Col
                            md={5}
                            className="resume-action-button"
                          >
                            <ConnectionRecommendationAction
                              item={item}
                              GetRecommendation={GetRecommendation}
                              setRecommendationList={setRecommendationList}
                              handleToggleDropdown={handleToggleDropdown}
                              index={index}
                              setShowDropdown={setShowDropdown}
                              showDropdown={showDropdown}
                            />
                          </Col>
                        </div>

                      </div>
                    </Row>
                  </>
                );
              })
            )}
            {/* {
              hasMoreDataRecom ? (''
              ) : (
                <p className="text-center">No more data available</p>
              )
            } */}
            {
              !hasMoreDataRecom && recommendationList.length > 10 && (

                <p className="text-center">{t("Newsfeed.No more data available")}</p>
              )
            }
            {/* {nextRecomBatchLoading && (
              <div className="text-center">
                <img src={post?.loader} width={50} />
              </div>
            )} */}
            {nextRecomBatchLoading && recommendationList.length > 0 && (
              <div className="text-center">
                <img src={post?.loader} width={50} />
              </div>
            )}
          </>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    setActiveTab(getConnectionTabIndex(tab));
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [tab]);

  const location = useLocation();

  useEffect(() => {
    if (location.state?.activeTab) {
      const tabPath = CONNECTION_TAB_ROUTES[location.state.activeTab];
      if (tabPath) {
        navigate(`/Connections/${tabPath}`, { replace: true, state: null });
      }
    }
  }, []);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  useEffect(() => {
    if (show || showModal) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open'); // When a modal opens
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open'); // When a modal closes
    }
  }, [show, showModal]);

  // -------------------------------------------------------------------------
  const { setIsNewsPageLoaded } = useNewsFeedStore();

  useEffect(() => {
    setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

    return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
  }, [setIsNewsPageLoaded]);

  // -------------------------------------------------------------------------

  return (
    <>
      <div className="main-container connectionPage p-2">
        <Row className="mt-3">
          <Col md={12}>
            <div
              className="Adwrapper"
              style={{
                display: 'flex', // Flexbox helps center the content
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '150px', // Fixed height for the wrapper
                overflow: 'hidden', // Ensure content doesn't exceed the wrapper
              }}
            >
              <div
                style={{
                  display: 'block', // Block-level element
                  width: '100%',
                  height: '150px', // Ensures the ad respects this height
                }}
              >
                <GoogleAdUnit
                  adSlot="5695666532"
                  layoutKey="-6t+ed+2i-1n-4w"
                  fullWidthResponsive={false}
                  style={{
                    display: 'block',
                    width: '100%',
                    height: '150px',
                    textAlign: 'center',
                    margin: '0 auto',
                  }}
                />
              </div>
            </div>

          </Col>
        </Row>
        <div className="advertisement m-auto ">
          <div className="friendsHeaderText  pt-0 pb-0 mt-4 ">
            <h1>{t("Connections.Connections")}</h1>
          </div>
        </div>

        <div className="tabButton d-flex w-100  ps-0 connectionTab allconnectionTab">
          {loading && <Loading />}
          <div
            role="button"
            tabIndex={0}
            onClick={() => goToConnectionTab(1)}
            className={`text-center pointer ${activeTab === 1 ? "activeTab" : ""}`}
          >
            <p className="f-14 tabName">{t("Connections.Connections")}</p>
          </div>
          <div
            role="button"
            tabIndex={0}
            onClick={() => goToConnectionTab(2)}
            className={`text-center pointer ${activeTab === 2 ? "activeTab" : ""}`}
          >
            <p className="f-14 tabName">{t("Connections.Sent Request")}</p>
          </div>
          <div
            role="button"
            tabIndex={0}
            onClick={() => goToConnectionTab(3)}
            className={`text-center pointer ${activeTab === 3 ? "activeTab" : ""}`}
          >
            <p className="f-14 tabName">{t("Connections.Received Request")}</p>
          </div>
          <div
            role="button"
            tabIndex={0}
            onClick={() => goToConnectionTab(4)}
            className={`text-center pointer ${activeTab === 4 ? "activeTab" : ""}`}
          >
            <p className="f-14 tabName">{t("Connections.Recommendations")}</p>
          </div>
        </div>

        <div className="resume-section ps-2 pe-2">{renderTabContent()}</div>
      </div>
      {show && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are You Sure You want to Cancel Request?")}</h6>

                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    cancelRequestClose();
                  }}
                >
                  close
                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    cancelRequestClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => CancelRequest(userUID)}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>
                  {t("modals.Are you sure you want to Disconnect")} <b>{selectedItem?.fullName}</b> ?
                </h6>

                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                >
                  close
                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => handleConfirmAction()}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
      {unauthorisedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                  <p className="text-center ad-p">
                    {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")}
                  </p>
                  <div className="text-center m-auto mt-3">
                    <button
                      type="button"
                      className="mainBtn1 "
                      onClick={() => {
                        setUnauthorisedModal(!unauthorisedModal)
                        navigate("/SignIn");
                        localStorage.clear();
                        sessionStorage.removeItem('hasModalShown');
                      }}
                    >
                      {t("modals.login")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Connection;
